import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableContainer } from "@mui/material";
import { COLORS } from "../../../../ui/Theme";

const MarketMoneyFlowTable = ({ tableData }) => {
  const colKeys = Object.keys(tableData.cols)
  const colValues = Object.values(tableData.cols)

  return (
    <TableContainer sx={{ minWidth: 300, overflow: "auto" }}>
      <Table size="small" sx={{ tableLayout: "auto", whiteSpace: "nowrap" }}>
        <TableHead>
          <TableRow>
            {colValues.map((col) => (
              <TableCell
                sx={{
                  fontWeight: 700,
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
                key={col}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.data.map((row) => (
            <TableRow key={row.id}>
              {colKeys.map(key => (
                <TableCell
                  key={key}
                  sx={{
                    textAlign: "center",
                    direction: "rtl",
                    color:
                      key === "money_flow"
                        ? row[key] > 0
                          ? COLORS.GREEN
                          : row[key] < 0
                            ? COLORS.RED
                            : null
                        : undefined,
                  }}
                >
                  {row[key]}
                </TableCell>
              ))}

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default MarketMoneyFlowTable


